import React, { useContext } from 'react';

import { withStyles } from '@material-ui/styles';
import { TableCell, TableRow } from '@material-ui/core';
import formatters from '../../../../Core/Grid/inputFormatter';
import { AppStorage } from '../../../../Core/Service/storage-service';
import { BranchFranchiseCompareContext } from './branchServicesProvider';

const StyledTableCell = withStyles((theme) => ({
    head: {
        fontSize: 12,
        padding: '4px',
        fontWeight: 700,
        border: '1px solid #ccc',
        textTransform: 'uppercase'
    },
    body: {
        fontSize: 12,
        padding: '4px',
        // border: 'none'
        border: '1px solid rgba(0, 0, 0, 0.03)'
        // border: '1px solid #ccc'
    }
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
    root: {
        '&:nth-of-type(odd)': {
            backgroundColor: '#F5F5F5'
        }
    }
}))(TableRow);

const DashboardYtdDataRow = ({ data, categoryName, kpiValue, kpiValueYTD, getOverallAccountCodeData, showToast, isNull, k, branchId, frenchise }) => {
    const isNegative = (value) => value < 0;
    const portalSettings = AppStorage.getPortalSetting();
    const { Collapse, ThousandSeparatorWithoutZero } = useContext(BranchFranchiseCompareContext);

    let actualAlign = portalSettings.portalSettingMADashboardActualAlign;
    let budgetAlign = portalSettings.portalSettingMADashboardBudgetAlign;
    let varianceAlign = portalSettings.portalSettingMADashboardVarianceAlign;
    let kpIsAlign = portalSettings.portalSettingMADashboardKPIsAlign;
    let actualPYAlign = portalSettings.portalSettingMADashboardActualPYAlign;
    let varLYAlign = portalSettings.portalSettingMADashboardVarPYAlign;
    let negativeBgColor = portalSettings.portalSettingMADashboardNegativeBgColor;
    let negativeTextColor = portalSettings.portalSettingMADashboardNegativeTxtColor;

    const getCellStyle = (value, bgColor, textColor) => ({
        color: isNegative(value) ? textColor : 'black',
        background: isNegative(value) ? bgColor : ''
    });

    const handleClick = () => {
        if (data.mappingCategoryID) {
            getOverallAccountCodeData(
                data.mappingCategoryID,
                branchId == '-99' ? '' : branchId,
                frenchise ? frenchise : '',
                data.maMappingCategoryName,
                k.categoryName
            );
        } else {
            showToast('No Record Found');
        }
    };

    const getFormatted = (val) => ThousandSeparatorWithoutZero(val, k?.dp);

    if (!Collapse[k.categoryId]) {
        if (isNull) {
            return (
                <StyledTableRow key={data.id}>
                    <StyledTableCell
                        align="left"
                        onClick={handleClick}
                        // onClick={
                        //     data.mappingCategoryID
                        //         ? () => getOverallAccountCodeData(data.mappingCategoryID, data.branch, null, data.maMappingCategoryName, categoryName)
                        //         : () => showToast('No Record Found')
                        // }
                        style={{
                            cursor: data.mappingCategoryID ? 'pointer' : '',
                            fontWeight: data.mappingCategoryID ? 500 : ''
                        }}
                    >
                        {data.maMappingCategoryName}
                    </StyledTableCell>

                    {/* MTD cells */}
                    <StyledTableCell align={actualAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>
                    <StyledTableCell align={budgetAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>
                    <StyledTableCell align={varianceAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0 || 0)}
                    </StyledTableCell>
                    <StyledTableCell align={kpIsAlign}>{'0%'}</StyledTableCell>
                    <StyledTableCell align={actualPYAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>
                    <StyledTableCell align={varLYAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>

                    {/* YTD cells */}
                    <StyledTableCell
                        align={actualAlign}
                        style={{
                            ...getCellStyle(0, negativeBgColor, negativeTextColor),
                            borderLeft: '2px solid grey'
                        }}
                    >
                        {getFormatted(0)}
                    </StyledTableCell>
                    <StyledTableCell align={budgetAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>
                    <StyledTableCell align={varianceAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0 || 0)}
                    </StyledTableCell>
                    <StyledTableCell align={kpIsAlign}>{'0%'}</StyledTableCell>
                    <StyledTableCell align={actualPYAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>
                    <StyledTableCell align={varLYAlign} style={getCellStyle(0, negativeBgColor, negativeTextColor)}>
                        {getFormatted(0)}
                    </StyledTableCell>
                </StyledTableRow>
            );
        } else {
            return (
                <StyledTableRow key={data.id}>
                    <StyledTableCell
                        align="left"
                        // onClick={
                        //     data.mappingCategoryID
                        //         ? () => getOverallAccountCodeData(data.mappingCategoryID, data.branch, null, data.maMappingCategoryName, categoryName)
                        //         : () => showToast('No Record Found')
                        // }
                        onClick={handleClick}
                        style={{
                            cursor: data.mappingCategoryID ? 'pointer' : '',
                            fontWeight: data.mappingCategoryID ? 500 : ''
                        }}
                    >
                        {data.maMappingCategoryName}
                    </StyledTableCell>

                    {/* MTD cells */}
                    <StyledTableCell align={actualAlign} style={getCellStyle(data.actual, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.actual, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={budgetAlign} style={getCellStyle(data.budget, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.budget, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={varianceAlign} style={getCellStyle(data.variance, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.variance || 0, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={kpIsAlign}>{kpiValue !== 0 ? parseFloat(kpiValue.toFixed(2)) + '%' : '0%'}</StyledTableCell>
                    <StyledTableCell align={actualPYAlign} style={getCellStyle(data.actualLY, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.actualLY, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={varLYAlign} style={getCellStyle(data.varLY, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.varLY, k?.dp)}
                    </StyledTableCell>

                    {/* YTD cells */}
                    <StyledTableCell
                        align={actualAlign}
                        style={{
                            ...getCellStyle(data.ytdActual, negativeBgColor, negativeTextColor),
                            borderLeft: '2px solid grey'
                        }}
                    >
                        {ThousandSeparatorWithoutZero(data.ytdActual, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={budgetAlign} style={getCellStyle(data.ytdBudget, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.ytdBudget, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={varianceAlign} style={getCellStyle(data.ytdVariance, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.ytdVariance || 0, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={kpIsAlign}>{kpiValueYTD !== 0 ? parseFloat(kpiValueYTD.toFixed(2)) + '%' : '0%'}</StyledTableCell>
                    <StyledTableCell align={actualPYAlign} style={getCellStyle(data.ytdActualLY, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.ytdActualLY, k?.dp)}
                    </StyledTableCell>
                    <StyledTableCell align={varLYAlign} style={getCellStyle(data.ytdVarLY, negativeBgColor, negativeTextColor)}>
                        {ThousandSeparatorWithoutZero(data.ytdVarLY, k?.dp)}
                    </StyledTableCell>
                </StyledTableRow>
            );
        }
    } else {
        return null;
    }
};

export default DashboardYtdDataRow;
